import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 20"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.723",
  d: "M8.092 13.207c3.689 0 6.842.558 6.842 2.791 0 2.234-3.132 2.809-6.842 2.809-3.69 0-6.842-.554-6.842-2.788s3.13-2.812 6.842-2.812m0-3.187a4.386 4.386 0 1 1 4.385-4.385 4.37 4.37 0 0 1-4.354 4.385z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.723",
  d: "M14.983 8.882A3.3 3.3 0 0 0 17.82 5.62a3.3 3.3 0 0 0-2.762-3.256m2.038 10.368c1.55.23 2.634.775 2.634 1.895 0 .77-.51 1.27-1.335 1.584"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }